// extracted by mini-css-extract-plugin
export default {"CommentField__button":"CommentField_CommentField__button__1A_5M","CommentField__textarea":"CommentField_CommentField__textarea__2WIbX"};